module.exports = __webpack_public_path__ + "media/pencil-edit-button.6e175c74.svg";